import { Collapse, CollapseItem, Button, Popover, Select, Option, Table, TableColumn } from 'element-ui';
import ResourceSvc from '@/services/resource.svc.js';
import 'element-ui/lib/theme-chalk/index.css';
import { EventBus } from '@/services/Event.js';
const svc = new ResourceSvc();
import RaceResult from '@/components/shared/race-result/race-result.vue';
import SeriesResultView from '@/components/user/ranking/series-result-view/series-result-view.vue';
import MedalDecider from '@/components/shared/medals/club/decider/decider.vue';

export default {
    name: 'ClubResult',
    props: ['selectedSerieIndex', 'selectedYearIndex'],
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [Button.name]: Button,
        [Popover.name]: Popover,
        [Select.name]: Select,
        [Option.name]: Option,
        'race-result': RaceResult,
        'series-result-view': SeriesResultView,
        'medal-decider': MedalDecider
    },
    data() {
        return {
            isUsersViewMode: true,
            isPreviewRaceResultsMode: false,
            isProcessing: false,
            errorMessage: null,
            data: [],
            years: ["Initialization"],
            selectedYear: null,
            selectedYearLabel: null,
            selectedSerie: null,
            selectedSerieLabel: null,
            noRacesEntry: { name: "No races found", id: null, enumValue: 0 },
            noUsersEntry: { name: "No users found", id: null },
            noClubsEntry: { clubName: "No clubs found", clubId: null },
            races: [],
            users: [],
            clubs: [],
            clubsInput: [],
            clubsFiltered: [],
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            page: 1,
            filterInput: null,
            activeRaceId: null,
            activeUserId: null,
            activeClubId: null,
            loadedResults: null,
            isProcessingRaces: false,
            isProcessingUsers: false,
            gender: 1,
            genderArray: [{ enumValue: 1, label: 'Male' }, { enumValue: 2, label: 'Female' }, { enumValue: 0, label: 'Mixed' }]
        };
    },
    computed: {
        currentRaceName() {
            var race = this.races.filter(x => x.id == this.activeRaceId);
            return race && race.length ? race[0].name : null;
        },
        isAnyClubsLoaded() {
            return this.clubsInput && this.clubsInput.length && this.clubsInput[0].id > 0;
        },
        isVisibleWorkflow() {
            return this.years && this.years.length;
        },
        isNotVisibleWorkflow() {
            return !this.isVisibleWorkflow && !this.isProcessing;
        },
        from() {
            var array = this.clubs;
            var totalVal = this.clubsFiltered.length;

            if (!array || !array.length || !array[0].id) return 0;

            var res = (this.page - 1) * this.perPage + 1;
            if (res >= totalVal) {
                if (totalVal - this.perPage > 0) {
                    res = totalVal - this.perPage;
                    if (res === 0) res = 1;
                }
                else {
                    res = 1;
                    this.page = 1;
                }
            }
            return res;
        },
        to() {
            var array = this.clubs;
            var totalVal = this.clubsFiltered.length;

            if (!array || !array.length || !array[0].id) return 0;
            return totalVal > (this.page - 1) * this.perPage + this.perPage
                ? (this.page - 1) * this.perPage + this.perPage
                : totalVal;
        },
        total() {
            var array = this.clubs;
            var totalVal = this.clubsFiltered.length;
            return (!array || !array.length || !array[0].id)
                ? 0
                : totalVal;
        }
    },
    methods: {
        serialize(obj) {
            var str = [];
            for (var p in obj)
                if (obj.hasOwnProperty(p)) {
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                }
            return str.join("&");
        },
        showError(message) {
            if (!message) message = 'Something went wrong. Incorrect request!';
            this.$notify({ message: message, type: 'danger', timeout: 3000 });
        },
        showSuccess(message) {
            if (!message) message = 'Operation success!';
            this.$notify({ message: message, type: 'success', timeout: 3000 });
        },
        console(message) {
            if (console && console.log) {
                if (message) console.log(message);
                else {
                    var date = new Date();
                    console.log("-------> " + date.getMinutes() + ":" + date.getSeconds());
                }
            }
        },
        setTabsInit() {
            var self = this;
            if (self.years && self.years.length) {
                self.selectedYear = self.years[self.selectedYearIndex > -1 ? self.selectedYearIndex : 0];
                self.selectedYearLabel = self.years[self.selectedYearIndex > -1 ? self.selectedYearIndex : 0] + '';
            }
            self.updateClubs();
        },
        init() {
            var self = this;
            self.isProcessing = true;
            self.races = [self.noRacesEntry];
            self.users = [self.noUsersEntry];
            self.clubs = [self.noClubsEntry];
            self.years = [];
            svc.rankingInitSeriesSettings()
                .then(response => {
                    self.isProcessing = false;

                    if (response && response.body) {
                        self.years = response.body.years
                        self.setTabsInit();
                    }
                    else {
                        self.errorMessage = "Something went wrong, please contact with dev team!";
                    }
                }, () => {
                    self.isProcessing = false;
                    self.errorMessage = "Something went wrong, please contact with dev team!";
                });

            EventBus.$off('view-race-results');
            EventBus.$on('view-race-results', id => self.loadRaceResult(id));
        },
        handleTabChangeYear(tabIndex) {
            if (this.isProcessing) {
                return;
            }
            this.selectedYear = this.years[tabIndex];
            this.updateClubs();

            if (this.selectedYearIndex != tabIndex) {
                EventBus.$emit('ranking-layout-set-init-year-index', tabIndex);
            }
        },
        clearRaces() {
            var self = this;
            self.races = [];
        },
        clearUsers() {
            var self = this;
            self.users = [];
        },
        clearClubs() {
            var self = this;
            self.clubs = [];
            self.clubsInput = [];
            self.clubsFiltered = [];
        },
        previousPage() {
            this.page--;
            this.changePage(this.page)
        },
        nextPage() {
            this.page++;
            this.changePage(this.page)
        },
        changePage(newPage) {
            var from = newPage ? (newPage - 1) * this.perPage : (this.page - 1) * this.perPage;
            if (from >= this.clubsFiltered.length) {
                if (this.clubsFiltered.length - this.perPage > 0) {
                    from = this.clubsFiltered.length - this.perPage;
                }
                else {
                    from = 0;
                    this.page = 1;
                }
            }

            if (!newPage) {
                this.page = 1;
            }
            this.clubs = [...this.clubsFiltered].splice(from, this.perPage);
        },
        searchFor(savePage) {
            var genderValue = this.gender;
            if (!savePage) {
                this.page = 1;
            }
            if (!this.filterInput) {
                this.clubsFiltered = [...this.clubsInput
                    .filter(club => { return club.gender === genderValue; })];
                this.clubs = [...this.clubsFiltered].splice(0, this.perPage);
                return;
            }

            var lowerfilterInput = this.filterInput && this.filterInput.length ? this.filterInput.toLocaleLowerCase() : null;

            if (lowerfilterInput) {
                this.clubsFiltered = [...this.clubsInput
                    .filter(club => {
                        return club.clubName.toLocaleLowerCase().indexOf(lowerfilterInput) > -1 && club.gender === genderValue;
                    })];
            }
            this.clubs = [...this.clubsFiltered].splice(0, this.perPage);
        },
        prepareRacesFromResponse(response) {
            var self = this;
            if (response && response.body && response.body.isSuccess) {
                self.races = response.body.outputData && response.body.outputData.length ? response.body.outputData : [self.noRacesEntry];
            }
            else {
                self.errorMessage = response && response.body && response.body.message ? response.body.message : "Error while retrieving data.";
            }
        },
        prepareUsersFromResponse(response) {
            var self = this;
            if (response && response.body && response.body.isSuccess) {
                self.users = response.body.outputData && response.body.outputData.length ? response.body.outputData : [self.noUsersEntry];
            }
            else {
                self.errorMessage = response && response.body && response.body.message ? response.body.message : "Error while retrieving data.";
            }
        },
        prepareClubsFromResponse(response) {
            var self = this;
            if (response && response.body && response.body.isSuccess) {
                self.clubsInput = response.body.outputData && response.body.outputData.length ? response.body.outputData : [self.noClubsEntry];
                self.searchFor();
            }
            else {
                self.errorMessage = response && response.body && response.body.message ? response.body.message : "Error while retrieving data.";
            }
        },
        updateRaces() {
            var self = this;
            self.clearRaces()

            if (self.activeUserId > 0) {
                self.isProcessingRaces = true;
                const filterQuery = self.serialize({ serieType: 2, year: self.selectedYear, userId: self.activeUserId });
                svc.rankingGetSeriesRacesForUser(filterQuery)
                    .then(response => {
                        self.prepareRacesFromResponse(response);
                        self.isProcessingRaces = false;
                    }, () => {
                        self.errorMessage = "Error while retrieving data."
                        self.isProcessingRaces = false;
                    });
            }
        },
        updateUsers() {
            var self = this;
            self.clearUsers()
            if (self.activeClubId && self.selectedYear) {
                self.isProcessingUsers = true;
                const filterQuery = self.serialize({ clubId: self.activeClubId, year: self.selectedYear, genderEnum: self.gender });
                svc.rankingGetSeriesForClub(filterQuery)
                    .then(response => {
                        self.prepareUsersFromResponse(response);
                        self.isProcessingUsers = false;
                    }, () => {
                        self.errorMessage = "Error while retrieving data."
                        self.isProcessingUsers = false;
                    });
            }
        },
        updateClubs() {
            var self = this;
            self.clearClubs()

            if (self.selectedYear) {
                self.isProcessing = true;
                const filterQuery = self.serialize({ year: self.selectedYear });
                svc.rankingGetClubs(filterQuery)
                    .then(response => {
                        self.prepareClubsFromResponse(response);
                        self.isProcessing = false;
                    }, () => {
                        self.errorMessage = "Error while retrieving data."
                        self.isProcessing = false;
                    });
            }
        },
        loadRaceResult(activeRaceId) {
            this.activeRaceId = activeRaceId;
            this.isPreviewRaceResultsMode = this.activeRaceId > 0
            EventBus.$emit('race-result-reload');
        },
        openClubData(clubId) {
            if (this.activeClubId == clubId) {
                this.activeClubId = null;
                return;
            }
            this.activeClubId = clubId;
            this.updateUsers();
        },
        download() {
            EventBus.$emit('race-result-download');
        },
        switchPreview() {
            var self = this;
            self.isPreviewRaceResultsMode = !self.isPreviewRaceResultsMode;
            setTimeout(() => {
                var item = document.getElementById('head-' + self.activeRaceId);
                if (item && item.getBoundingClientRect && item.getBoundingClientRect()) {
                    window.scrollTo({ top: item.getBoundingClientRect().y - 100, behavior: 'smooth' });
                }
            }, 10)
        }
    },
    mounted() {
        var self = this;
        self.init();

        EventBus.$off('club-result-update-races')
        EventBus.$on('club-result-update-races', (userId) => {
            self.activeUserId = userId;
            self.updateRaces();
        });

        EventBus.$off('club-result-load-race-results');
        EventBus.$on('club-result-load-race-results', (raceId) => {
            self.loadRaceResult(raceId);
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/user/ranking/club-result/club-result.js